module.exports = __webpack_public_path__ + "img/bds_wall-box_24.bb087827.svg";